import { LOCAL_KEY_FOLDER_VIEW_TYPE_LIST } from 'src/common/const';

import type { LocalFolderViewType } from './use-folder';

export const getLocalFolderViewTypeList = (): LocalFolderViewType => {
  const str = localStorage.getItem(LOCAL_KEY_FOLDER_VIEW_TYPE_LIST);
  return str ? JSON.parse(str) : {};
};
